import { v4 as uuidv4 } from 'uuid';

export function NewsletterForm(props = {}, childrenComponents = []) {
	return {
		componentName: 'NewsletterForm',
		componentId: uuidv4(),
		props: Object.assign(
			{
				SuccessState: '',
				ErrorState: '',
				LoadingState: '',
				classes: '',
			},
			props,
		),
		childrenComponents,
	};
}
